import type { CallPurpose } from "./types";

export const CALL_PURPOSES: ReadonlyArray<{
  value: CallPurpose;
  label: string;
  instruction: string;
}> = [
  { value: "EXAMINATION", label: "เข้าตรวจ", instruction: "กรุณาเข้าตรวจ" },
  {
    value: "COORDINATION",
    label: "ติดต่อประสานงาน",
    instruction: "กรุณาติดต่อประสานงาน",
  },
  {
    value: "DOCUMENT_PICKUP",
    label: "รับเอกสาร",
    instruction: "กรุณารับเอกสาร",
  },
  { value: "MEET_RELATIVE", label: "พบญาติ", instruction: "กรุณาพบญาติ" },
];

export function callPurposeLabel(purpose: CallPurpose | null) {
  return CALL_PURPOSES.find((item) => item.value === purpose)?.label ?? null;
}

export function callPurposeInstruction(purpose: CallPurpose | null) {
  return CALL_PURPOSES.find((item) => item.value === purpose)?.instruction ?? null;
}
